import { message } from 'antd';
import { AttachmentsAPI } from 'api/attachments';

/**
 * This is an extension to Ant's existing utils.
 * We would need a util that can return the file type
 * based on the url instead of a `UploadFile` type.
 */
export const extname = (filePath: string): string => {
  const temp = filePath?.split('/');
  const filename = temp?.[temp?.length - 1];
  const filenameWithoutSuffix = filename?.split(/#|\?/)[0];

  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])?.[0]?.split?.(
    '.',
  )?.[1];
};

export const isImageUrlFromExtension = (filePath: string): boolean => {
  const extension = extname(filePath);

  if (
    /^data:image\//.test(filePath) ||
    /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)
  ) {
    return true;
  }

  return false;
};

export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const kbValue = 1024;
  const decimalPoints = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];

  const convBase = Math.floor(Math.log(bytes) / Math.log(kbValue));

  return `${parseFloat((bytes / kbValue ** convBase).toFixed(decimalPoints))} ${
    sizes[convBase]
  }`;
};

export const openFileUrl = (
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  _id: number | undefined,
  downloadAttachmentErrorText: string,
) => {
  e.preventDefault();
  e.stopPropagation();

  if (!_id) {
    return;
  }
  AttachmentsAPI.getAttachment(_id).then(
    (attachment) => {
      const $a = document.createElement('a');
      const downloadUrl = attachment.downloadUrl || attachment.location || '';

      $a.href = downloadUrl;
      $a.download = downloadUrl;
      $a.target = '_blank';
      document.body.appendChild($a);
      $a.click();
      document.body.removeChild($a);
    },
    () => {
      message.error(downloadAttachmentErrorText);
    },
  );
};
